import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: config.apiGatewayUrl,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const notificationCenterApi = {
  getGroups: (params) => instance().get('notification-center/groups', { params })
}

export default notificationCenterApi



// WEBPACK FOOTER //
// ./src/api/notification-center.js